import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import ServiceOrdersLoader from './_load/ServiceOrdersLoader'
import ServiceOrdersTable from './table/ServiceOrdersTable'

const FormReplyServiceOrdersModal = props => {
  return (
    <ControlledModal width="68rem" {...props}>
      <ModalHeader />

      <LineSeparator color="light2" weight={4} />

      <FilterHandler>
        <ServiceOrdersLoader>
          <ServiceOrdersTable />
        </ServiceOrdersLoader>
      </FilterHandler>

      <Separator weight={6} />
    </ControlledModal>
  )
}

export default FormReplyServiceOrdersModal
